<template>
  <BaseModal @close="$emit('close')">
    <div class="p-4">
      <h2 class="text-xl font-bold mb-4">
        Add New <span class="text-[#B203BC]">Competitor</span>
      </h2>
      
      <!-- Success Feedback Message -->
      <div
        v-if="feedbackMessage && feedbackType === 'success'"
        class="mb-4 flex flex-col items-center justify-center text-green-600"
      >
        <div class="text-8xl mb-15 mt-10">✅</div>
        <div class="mt-10 text-center">
          {{ feedbackMessage }}
        </div>
      </div>

      <!-- Error Feedback Message -->
      <div
        v-if="feedbackMessage && feedbackType === 'error'"
        class="mb-4 text-red-600 text-center"
      >
        {{ feedbackMessage }}
      </div>

      <!-- Show form only if submission wasn’t successful -->
      <div v-if="feedbackType !== 'success'" >
        <div class="mb-4">
          <label class="block text-gray-700 mb-2" for="competitor">
            Competitor
          </label>
          <input
            v-model="competitor"
            id="competitor"
            type="text"
            class="w-full border rounded px-3 py-2 border-b-[#B203BC]"
            placeholder="Enter competitor name (required)"
          />
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 mb-2" for="weblink">
            Weblink
          </label>
          <input
            v-model="weblink"
            id="weblink"
            type="text"
            class="w-full border rounded px-3 py-2 border-b-[#B203BC]"
            placeholder="Enter competitor website (optional)"
          />
        </div>
        <div class="flex justify-end">
          <button
            @click="submitCompetitor"
            :disabled="!competitor || isSubmitting"
            class="bg-[#B203BC] text-white px-4 py-2 rounded disabled:opacity-50"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "./BaseModal.vue";
import { useCompetitorStore } from "../stores/useCompetitorStore";
import { useMainStore } from "../stores/useMainStore";

export default {
  name: "AddCompetitorModal",
  components: { BaseModal },
  data() {
    return {
      competitor: "",
      weblink: "",
      isSubmitting: false,
      feedbackMessage: "",
      feedbackType: "", // 'success' or 'error'
    };
  },
  methods: {
    async submitCompetitor() {
      if (!this.competitor) return;

      this.isSubmitting = true;
      const competitorStore = useCompetitorStore();

      try {
        await competitorStore.addCompetitor({
          competitor: this.competitor,
          weblink: this.weblink,
        });
        // Show success message with a centered emoji
        this.feedbackMessage =
          "Great job! Your competitor was added successfully. We're now keeping an eye on it and will update you when new data arrives.";
        this.feedbackType = "success";

        // Auto-close modal after 3.5 seconds
        setTimeout(() => {
          const mainStore = useMainStore();
          mainStore.closeAddCompetitorModal();
        }, 3500);
      } catch (error) {
        console.error("Error adding competitor:", error);
        this.feedbackMessage = "Error adding competitor. Please try again.";
        this.feedbackType = "error";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
